import React from 'react';
import Order from '../../modules/order';

const OrderWrapper = (props) => {
  return <Order {...props} />;
}

export default OrderWrapper;